import {ID, Resource} from 'simpli-web-sdk'
import DeliveryCanceledResponseSchema from '@/schema/DeliveryCanceledResponse.schema'
import Motorista from '@/model/resource/Motorista'
import Carga from '@/model/resource/Carga'

export default class DeliveryCanceledResponse extends Resource {

  readonly $name: string = 'DeliveryCanceledResponse'
  readonly $endpoint: string = '/user/indicador/entrega-cancelada'

  get $id() {
    return this.id
  }
  set $id(val: ID) {
    this.id = val
  }

  get $schema() {
    return DeliveryCanceledResponseSchema(this)
  }

  id: ID = 0
  motorista: Motorista | null = null
  carga: Carga | null  = null
  data: string | null  = null
  justificativa: string | null = null
  manifesto: string | null = null

}
